import {Box} from '@mantine/core';
import Image from 'next/image';
import type {PropsWithChildren} from 'react';
import {GoogleAdBannerName} from '../../../config/constants/googleAdBanner';
import {LINE_NOTIFICATION_BANNER_IMAGE} from '../../../config/constants/img';
import {EXTERNAL_SERVICES_LINE_SEETTING} from '../../../config/constants/routes';
import isAppWebView from '../../../config/isAppWebView';
import {isReleasedRedesignRecruitment} from '../../../config/unReleasePage';
import {useAuth} from '../../../core/usecases/useAuth';
import {GoogleAdBanner} from '../../../shared/components/Banner/GoogleAdBanner';
import {CommonLink} from '../../../shared/components/CommonLink';
import {GeneralFooter} from '../../../shared/components/Footer/general';
import {GeneralHeaderContainer} from '../../../shared/components/Header/General/container';
import {PcCommunityTopicsHeadline} from '../../../shared/components/Sidebar/PcCommunityTopicsHeadline';
import {SignUp} from '../../../shared/components/Sidebar/SignUp';
import {useGoogleAdBanner} from '../../../shared/services/useGoogleAdBanner';
import {useMediaQuery} from '../../../shared/services/useMediaQuery';

export const RecruitmentDetailLayout = ({children}: PropsWithChildren) => {
  const {isSignedIn} = useAuth();
  const {isPC} = useMediaQuery();

  // DFPバナーのセット
  const googleAdBannerNames = [
    GoogleAdBannerName.RICH_DESKTOP_HEADER,
    GoogleAdBannerName.B_RECTANGLE,
    GoogleAdBannerName.B_RECTANGLE_BOTTOM,
  ];
  useGoogleAdBanner(googleAdBannerNames);

  return (
    <>
      <div>
        {!isAppWebView() && <GeneralHeaderContainer />}
        <main>
          <Box className="flex min-h-screen flex-col items-center bg-background-1 py-12 pc:py-32">
            {isReleasedRedesignRecruitment() ? (
              <>
                <div className="hidden pc:block">
                  <GoogleAdBanner
                    googleAdBannerName={GoogleAdBannerName.RICH_DESKTOP_HEADER}
                  />
                </div>
                {children}
              </>
            ) : (
              <div className="mx-auto my-0 max-w-[1200px]">
                {isPC && (
                  <GoogleAdBanner
                    googleAdBannerName={GoogleAdBannerName.RICH_DESKTOP_HEADER}
                  />
                )}
                <div className="flex justify-between pc:mt-[10px]">
                  {/* 左・中央カラム */}
                  <div className="w-full pc:w-[880px]">{children}</div>
                  {/* 右カラム */}
                  {isPC && (
                    <Box className="w-[300px] ml-20 sticky">
                      <div className="h-[250px]">
                        <GoogleAdBanner
                          googleAdBannerName={GoogleAdBannerName.B_RECTANGLE}
                        />
                      </div>
                      <div className="mt-16">
                        <CommonLink
                          href="https://event.gaishishukatsu.com/"
                          className="block pc:hover:opacity-80"
                          target="_blank"
                        >
                          <Image
                            src="/next-image/event/banner_gsskt_event.svg"
                            alt="外資就活主催イベント一覧"
                            width={300}
                            height={80}
                          />
                        </CommonLink>
                      </div>
                      <div className="mt-16">
                        <PcCommunityTopicsHeadline />
                      </div>
                      {!isSignedIn && <SignUp />}
                      <div className="mt-16">
                        <CommonLink href={EXTERNAL_SERVICES_LINE_SEETTING}>
                          <Image
                            src={LINE_NOTIFICATION_BANNER_IMAGE}
                            alt="LINE連携の設定はこちら"
                            width={300}
                            height={150}
                          />
                        </CommonLink>
                      </div>
                      <div className="mt-16 h-[250px]">
                        <GoogleAdBanner
                          googleAdBannerName={
                            GoogleAdBannerName.B_RECTANGLE_BOTTOM
                          }
                        />
                      </div>
                    </Box>
                  )}
                </div>
              </div>
            )}
          </Box>
        </main>
        {!isAppWebView() && <GeneralFooter />}
      </div>
    </>
  );
};
